module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Official Website of Josh Mu","short_name":"Josh Mu","description":"A website to show all the things Josh Mu loves to do.","lang":"en","display":"standalone","icon":"src/images/icon.png","start_url":"/","background_color":"#000","theme_color":"#fff"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
